export default "__VITE_ASSET__Cni0yeQ___"